import React, { useContext, useState } from "react";
import {
  DefaultButton,
  Dropdown,
  IconButton,
  Modal,
  PrimaryButton,
  TextField,
} from "@fluentui/react";
import "./ReturnStudyModal.css";
import ModalHeader from "../../../../components/Modal/ModalHeader";
import ModalFooter from "../../../../components/Modal/ModalFooter";
import { useTranslation } from "react-i18next";
import { ReturnStudyApi } from "../../../../service/StudyViewerService";
import studyviewerContext from "../../../../context/studyviewer/StudyviewerContext";
import studyReportContext from "../../../../context/studyreport/StudyReportContext";
import ModalMain from "../../../../components/Modal/ModalMain";
import themeContext from "../../../../context/theme/ThemeContext";
import { isMobile } from "react-device-detect";

const ReturnStudyModal = (props) => {
  const { t } = useTranslation();

  const { studyParentId, patientStudyData, studyResponseData } =
    useContext(studyviewerContext);
  const { unlockStudy } = useContext(studyReportContext);
  const [errorMessage, setErrorMessage] = useState("");
  const [isError, setIsError] = useState(false);
  const { getThemeColor } = useContext(themeContext);
  const [isOtherReason, setIsOtherReason] = useState(false);
  // const reasonsList = [
  //   { key: "Case out of scope", text: t("return-study-reasons.case-out-of-scope") },
  //   { key: "Study out of scope", text: t("return-study-reasons.study-out-of-scope") },
  //   { key: "Poor Quality", text: t("return-study-reasons.poor-quality") },
  //   {
  //     key: "Incomplete study",
  //     text: t("return-study-reasons.incomplete-study"),
  //   },
  //   {
  //     key: "Inadequate history",
  //     text: t("return-study-reasons.inadequate-history"),
  //   },
  //   {
  //     key: "Need aditional information/documentation",
  //     text: t("return-study-reasons.need-info"),
  //   },
  //   {
  //     key: "Unable to come to a conclusion on diagnosis",
  //     text: t("return-study-reasons.not-concluded"),
  //   },
  //   { key: "Lack of time", text: t("return-study-reasons.lack-of-time") },
  //   { key: "Scan not normal", text: t("return-study-reasons.not-normal") },
  //   {
  //     key: "Reference / CT cuts",
  //     text: t("return-study-reasons.reference-CT-cuts"),
  //   },
  //   {
  //     key: "Not for reporting",
  //     text: t("return-study-reasons.not-for-reporting"),
  //   },
  //   { key: "Double entry", text: t("return-study-reasons.double-entry") },
  //   { key: "Other", text: t("return-study-reasons.other") },
  // ];

  const reasonsList = [
    ...(process.env.REACT_APP_VDC_PLATFORM === "true" || process.env.REACT_APP_VDC_PLATFORM === true
      ? [
        { key: "Case out of scope", text: t("return-study-reasons.case-out-of-scope") },
        { key: "Study out of scope", text: t("return-study-reasons.study-out-of-scope") },
        { key: "Poor Quality", text: t("return-study-reasons.poor-quality") },
        { key: "Incomplete study", text: t("return-study-reasons.incomplete-study"),},
        { key: "Inadequate history", text: t("return-study-reasons.inadequate-history"),},
        { key: "Need aditional information/documentation", text: t("return-study-reasons.need-info"),},
        { key: "Unable to come to a conclusion on diagnosis", text: t("return-study-reasons.not-concluded"),},
        { key: "Lack of time", text: t("return-study-reasons.lack-of-time") },
        { key: "Scan not normal", text: t("return-study-reasons.not-normal") },
        { key: "Reference / CT cuts", text: t("return-study-reasons.reference-CT-cuts"),},
        { key: "Not for reporting", text: t("return-study-reasons.not-for-reporting"),},
        { key: "Double entry", text: t("return-study-reasons.double-entry") },
        { key: "Other", text: t("return-study-reasons.other") },
      ]
      : [
        { key: "Not having expertise to report", text: t("return-study-reasons-2.no-expertise") },
        { key: "Poor quality", text: t("return-study-reasons-2.poor-quality") },
        { key: "Incomplete study", text: t("return-study-reasons-2.incomplete-study") },
        {
          key: "Inadequate clinical details. Need detail history",
          text: t("return-study-reasons-2.inadequate-history"),
        },
        { key: "Lack of time", text: t("return-study-reasons-2.lack-of-time") },
        {
          key: "Reference / CT cuts",
          text: t("return-study-reasons-2.reference-CT-cuts"),
        },
        { key: "Double entry", text: t("return-study-reasons-2.double-entry") },
        { key: "Other", text: t("return-study-reasons-2.other") },]),
  ];

  const mobileReasonsList = [
    ...(process.env.REACT_APP_VDC_PLATFORM === "true" || process.env.REACT_APP_VDC_PLATFORM === true
      ? [
        { key: "Case out of scope", text: t("return-study-reasons.case-out-of-scope") },
        { key: "Study out of scope", text: t("return-study-reasons.study-out-of-scope") },
        { key: "Poor Quality", text: t("return-study-reasons.poor-quality") },
        { key: "Incomplete study", text: t("return-study-reasons.incomplete-study"),},
        { key: "Inadequate history", text: t("return-study-reasons.inadequate-history"),},
        { key: "Need aditional information/documentation", text: t("return-study-reasons.need-info"),},
        { key: "Unable to come to a conclusion on diagnosis", text: t("return-study-reasons.not-concluded"),},
        { key: "Lack of time", text: t("return-study-reasons.lack-of-time") },
        { key: "Scan not normal", text: t("return-study-reasons.not-normal") },
        { key: "Reference / CT cuts", text: t("return-study-reasons.reference-CT-cuts"),},
        { key: "Not for reporting", text: t("return-study-reasons.not-for-reporting"),},
        { key: "Double entry", text: t("return-study-reasons.double-entry") },
        { key: "Other", text: t("return-study-reasons.other") },
      ]
      : [
        { key: "Poor Quality", text: t("return-study-reasons.poor-quality") },
        {
          key: "Incomplete study",
          text: t("return-study-reasons.incomplete-study"),
        },
        {
          key: "Inadequate history",
          text: t("return-study-reasons.inadequate-history"),
        },
        {
          key: "Need aditional information/documentation",
          text: t("return-study-reasons.need-info"),
        },
        {
          key: "Unable to come to a conclusion on diagnosis",
          text: t("return-study-reasons.not-concluded"),
        },
        { key: "Lack of time", text: t("return-study-reasons.lack-of-time") },
        { key: "Scan not normal", text: t("return-study-reasons.not-normal") },
        {
          key: "Reference / CT cuts",
          text: t("return-study-reasons.reference-CT-cuts"),
        },
        {
          key: "Not for reporting",
          text: t("return-study-reasons.not-for-reporting"),
        },
        { key: "Double entry", text: t("return-study-reasons.double-entry") },]),
  ];

  const [reason, setReason] = useState("select");
  const [otherReason, setOtherReason] = useState("");

  const hideReturnStudyModal = () => {
    props.setShowReturnStudyModal(false);
  };

  const handleChangeReason = (event, selected) => {
    setReason(selected.key);
    if (selected.key === "Other") {
      setIsOtherReason(true);
    } else {
      setIsOtherReason(false);
      setOtherReason("");
    }
    // setIsOtherReason(selected.key==="Other");
  };


  const getDropDownReasonList = () => {
    if(isMobile) {
      return [{ key: "select", text: "Select" }, ...mobileReasonsList]
    } else {
      return [{ key: "select", text: "Select" }, ...reasonsList]
    }
  }

  let PrimaryButtonList = [
    {
      title: t("button.yes"),
      onclick: () => {
        console.log(isOtherReason);
        console.log(otherReason);
        if (isOtherReason && (otherReason === "" || otherReason === null)) {
          setIsError(true);
          setErrorMessage(t("QC.specify-other-reason"));
          return;
        }
        setIsError(false);
        unlockStudy(studyParentId, isOtherReason, reason, otherReason);
      },
    },
  ];
  let DefaultButtonList = [
    {
      title: t("button.no"),
      onclick: () => {
        setIsError(false);
        hideReturnStudyModal();
      },
    },
  ];

  const modalDetails = {
    header: (
      <ModalHeader
        patientName={studyResponseData?.patientName}
        patientID={studyResponseData?.patientId}
        heading={t("return-study.studyviewer.title")}
        handleCancel={hideReturnStudyModal}
        updatedModal={true}
      />
    ),
    body: (
      <div className="return-study-container">
        <div className="return-study-content">
          <div className="ReturnStudyContentContainer">
            <div className="content-1">
              <label
                style={{ color: getThemeColor("primary-color") }}
                className="label"
              >
                {t("return-study.studyviewer.reason-to-return")}
              </label>
              <Dropdown
                placeholder={t("return-study.studyviewer.select-reason")}
                options={getDropDownReasonList()}
                selectedKey={reason}
                onChange={handleChangeReason}
                styles={isMobile ? {} : {
                  width: "100px",
                  dropdownItemsWrapper: {
                    maxHeight: "100px",
                  },
                }}
              />
            </div>
            {isOtherReason && (
              <div className="content-2">
                <label className="label">
                  {t("return-study.studyviewer.other")}
                </label>
                <TextField
                  className="other-textArea"
                  name="other"
                  onChange={(e) => {
                    setOtherReason(e.target.value);
                  }}
                  value={otherReason}
                  // disabled={!isOtherReason}
                />
              </div>
            )}
            <div
              style={{
                width: "100%",
                display: `${isError ? "flex" : "none"}`,
                justifyContent: "center",
                alignItems: "center",
                paddingTop: "10px",
              }}
            >
              <span style={{ color: "red" }}>{errorMessage}</span>
            </div>
          </div>
        </div>
      </div>
    ),
    footer: (
      <ModalFooter
        PrimaryButtonList={PrimaryButtonList}
        DefaultButtonList={DefaultButtonList}
      />
    ),
    width: "400px",
  };

  return (
    <>
      <ModalMain
        updatedModal={true}
        modalDetails={modalDetails}
        showModal={true}
      />
    </>
  );
};

export default ReturnStudyModal;
